import { Box, Typography, styled } from '@mui/material'

import { useAppStore } from '@/store'
import { RULES_STATUS } from '@/utils/constants'
import { Chip } from '@/components/UI/Chip'

type AssessmentRowProps = {
  title: string
  value: string
  isFirst?: boolean
  isLast?: boolean
  roundedTop?: boolean
  roundedBottom?: boolean
  inlineStyle?: {}
}

export const DecisionSummary = ({ loanRulesByCategory }: any) => {
  const { selectedApplication } = useAppStore()

  const assessments = [
    { title: 'General Eligibility', category: loanRulesByCategory.general },
    { title: 'Credit Risk Scorecard', category: loanRulesByCategory.creditrisk },
    { title: 'Decision Rules', category: loanRulesByCategory.decision },
    { title: 'Refer Rules', category: loanRulesByCategory.refer },
    { title: 'Catch All Rules', category: loanRulesByCategory.catchallrule },
  ]

  const AssessmentRow = ({
    title,
    value,
    isFirst,
    isLast,
    roundedTop,
    roundedBottom,
    inlineStyle,
  }: AssessmentRowProps) => (
    <Box sx={{ display: 'flex', ...inlineStyle }}>
      <StyledBox
        sx={{
          ...(isFirst || roundedTop ? { borderTopLeftRadius: '8px' } : {}),
          ...(isLast || roundedBottom ? { borderBottomLeftRadius: '8px' } : {}),
        }}
      >
        <StyledText>{title}</StyledText>
      </StyledBox>
      <StyledBox
        sx={{
          justifyContent: 'flex-end',
          ...(isFirst || roundedTop ? { borderTopRightRadius: '8px' } : {}),
          ...(isLast || roundedBottom ? { borderBottomRightRadius: '8px' } : {}),
        }}
      >
        <Chip value={value?.toUpperCase() || ''} />
      </StyledBox>
    </Box>
  )

  return (
    <>
      <Box
        p={2}
        sx={{
          border: '1px solid #EAECF0',
          borderBottom: 'none',
          borderTop: 'none',
        }}
      >
        <StyledHeading mb={1}>Application Decision Summary</StyledHeading>
        <Box>
          {assessments.map((item, index) => (
            <AssessmentRow
              key={item.title}
              title={item.title}
              value={item?.category?.eligibilityStatus ?? RULES_STATUS.NOT_APPLICABLE}
              isFirst={index === 0}
              isLast={index === assessments.length - 1}
            />
          ))}
        </Box>

        <AssessmentRow
          title="System Decision"
          value={selectedApplication.status}
          roundedTop
          roundedBottom
          inlineStyle={{ mt: 2 }}
        />
      </Box>
    </>
  )
}

const StyledHeading = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 600,
  textAlign: 'left',
}))

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 12px',
  border: '1px solid #E4E7EC',
  width: '50%',
  height: '40px',
}))

const StyledText = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '20px',
  textAlign: 'left',
  color: '#475467',
}))
